import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
function Landing() {
     const navigate = useNavigate();

         useEffect(() => {
						AOS.init({ duration: 2000 });
						
					}, []); 
  return (
		<div className="row landing">
			<div
				className="col-md-10 my-auto text-center  justify-content-center"
				style={{ borderRight: "10px solid white" }}>
				<h2
					data-aos="fade-right"
					style={{ color: "white", fontSize: "150px", marginBottom: "40px" }}>
					Poly Hotel
				</h2>
				<h1 data-aos="zoom-in" style={{ color: "white", marginBottom: "40px" }}>
					There is only one Boss.The Guest{" "}
				</h1>
				<button
					data-aos="fade-right"
					className="btn "
					style={{ backgroundColor: "white", color: "black" }}
					onClick={() => {
						navigate("/home");
					}}>
					Get Started
				</button>
			</div>
		</div>
	);
}

export default Landing